import {
  Button,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import React, {useState} from 'react';
import {IoCloseCircleOutline} from 'react-icons/io5';
import AddeparManager from '../../api/addeparManager';
import '../../App.css';
import {useAddepar} from '../../hooks/use-adepar';
import {useAuth} from '../../hooks/use-auth';
import {Modal} from '../modal/modal';

export const AddeparModal = ({active, setActive}) => {
  const {
    state: {profile},
  } = useAuth();

  const [index, setIndex] = useState(0);
  const [form, setForm] = useState({
    uid: profile.uid,
    customerID: profile.customerID,
    api_key: '',
    secret: '',
    account_mappings: [
      {
        entity_name: '',
        account_name: '',
        owner_id: '',
        entity_id: '',
      },
    ],
    error: null,
  });

  return (
    <Modal active={active} setActive={setActive} disabled_dismiss={true}>
      <div className="box flex-column">
        {index === 0 && (
          <AddeparCredentials
            form={form}
            setForm={setForm}
            setIndex={setIndex}
            setActive={setActive}
          />
        )}
        {index === 1 && (
          <AccountMapping
            form={form}
            setForm={setForm}
            setIndex={setIndex}
            setActive={setActive}
          />
        )}
      </div>
    </Modal>
  );
};

const AddeparCredentials = ({form, setForm, setIndex, setActive}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Function to validate credentials
  const validateCredentials = () => {
    return form.api_key && form.secret;
  };

  // Function to handle next step
  const handleNext = () => {
    if (!validateCredentials()) {
      setError('Please fill out both API Key and Secret before proceeding');
      return;
    }
    setIndex(1);
    setLoading(false);
  };

  return (
    <div>
      <IconButton
        aria-label="close"
        onClick={() => setActive(false)}
        style={{position: 'absolute', top: 8, right: 8}}>
        <IoCloseCircleOutline />
      </IconButton>

      <Typography sx={{textAlign: 'center', fontSize: '22px'}}>
        Addepar Credentials
      </Typography>
      <Typography sx={{textAlign: 'center'}}>
        The Addepar API key and secret are created in Addepar and entered below.
      </Typography>
      {error && (
        <Typography sx={{textAlign: 'center', color: 'red', marginTop: 2}}>
          {error}
        </Typography>
      )}
      <div className="box">
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Typography>Addepar API Key:</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="API Key"
                label="API Key"
                placeholder="API Key"
                value={form.api_key}
                type="text"
                onChange={evt => {
                  setForm({...form, api_key: evt.target.value});
                  setError(''); // Clear error when user makes changes
                }}
                variant="filled"
              />
            </FormControl>
          </Grid>
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
              <Typography>Addepar Secret:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id="Secret"
                  label="Secret"
                  placeholder="Secret"
                  value={form.secret}
                  type="text"
                  onChange={evt => {
                    setForm({...form, secret: evt.target.value});
                    setError(''); // Clear error when user makes changes
                  }}
                  variant="filled"
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}>
        <Button
          onClick={() => setActive(false)}
          style={{
            zIndex: 1,
            backgroundColor: '#c5c7c6',
            height: '30px',
            border: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0px 32px',
            margin: '16px 32px 0px 32px',
            color: 'black',
          }}>
          Cancel
        </Button>
        <Button
          disabled={loading}
          style={{
            zIndex: 1,
            backgroundColor: '#c5c7c6',
            height: '30px',
            border: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0px 32px',
            margin: '16px 32px 0px 32px',
            color: 'black',
          }}
          onClick={handleNext}>
          Next
        </Button>
      </div>
    </div>
  );
};

const AccountMapping = ({form, setForm, setIndex, setActive}) => {
  const {createConnection} = useAddepar();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Get the current mapping being edited (last item in the array)
  const currentMapping =
    form.account_mappings[form.account_mappings.length - 1];

  // Function to validate the current mapping
  const validateMapping = mapping => {
    return (
      mapping.entity_name &&
      mapping.account_name &&
      mapping.owner_id &&
      mapping.entity_id
    );
  };

  // Function to update the current mapping
  const updateCurrentMapping = (field, value) => {
    const newMappings = [...form.account_mappings];
    newMappings[newMappings.length - 1] = {
      ...newMappings[newMappings.length - 1],
      [field]: value,
    };
    setForm({...form, account_mappings: newMappings});
    setError(''); // Clear any previous errors when user makes changes
  };

  // Function to add a new empty mapping
  const addNewMapping = async () => {
    if (!validateMapping(currentMapping)) {
      setError('Please fill out all fields before adding a new mapping');
      return;
    }

    setLoading(true);
    setError('');

    // Validate the current mapping with Addepar
    // const entity_response = await AddeparManager.getEntity(
    //   currentMapping.entity_id,
    // );
    // const owner_response = await AddeparManager.getEntity(
    //   currentMapping.owner_id,
    // );

    // if (!entity_response.data.success) {
    //   setError('Entity not found in Addepar');
    //   setLoading(false);
    //   return;
    // }

    // if (!owner_response.data.success) {
    //   setError('Owner not found in Addepar');
    //   setLoading(false);
    //   return;
    // }
    // If validation passes, add the new mapping
    setForm({
      ...form,
      account_mappings: [
        ...form.account_mappings,
        {entity_name: '', account_name: '', owner_id: '', entity_id: ''},
      ],
    });
    setError('');
    setLoading(false);
  };

  // Function to handle completion
  const handleDone = async () => {
    if (!validateMapping(currentMapping)) {
      setError('Please fill out all fields before completing');
      return;
    }

    setLoading(true);
    setError('');

    // Validate the current mapping with Addepar
    const entity_response = await AddeparManager.getEntity(
      currentMapping.entity_id,
    );
    const owner_response = await AddeparManager.getEntity(
      currentMapping.owner_id,
    );

    if (!entity_response.data.success) {
      setError('Entity not found in Addepar');
      setLoading(false);
      return;
    }

    if (!owner_response.data.success) {
      setError('Owner not found in Addepar');
      setLoading(false);
      return;
    }

    // If validation passes, create the connection
    const {success, error} = await createConnection(form);
    if (!success) {
      setError(error);
      setLoading(false);
      return;
    }

    setIndex(0);
    setActive(false);
    setLoading(false);
  };

  return (
    <div>
      <IconButton
        aria-label="close"
        onClick={() => setActive(false)}
        style={{position: 'absolute', top: 8, right: 8}}>
        <IoCloseCircleOutline />
      </IconButton>

      <Typography sx={{textAlign: 'center', fontSize: '22px'}}>
        Account Mapping
      </Typography>
      {error && (
        <Typography sx={{textAlign: 'center', color: 'red', marginTop: 2}}>
          {error}
        </Typography>
      )}
      <div className="box">
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Typography>Forest Entity Name:</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="Entity Name"
                label="Entity Name"
                placeholder="Entity Name"
                value={currentMapping.entity_name}
                type="text"
                onChange={evt =>
                  updateCurrentMapping('entity_name', evt.target.value)
                }
                variant="filled"
              />
            </FormControl>
          </Grid>
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
              <Typography>Forest Account Name:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id="Forest Account Name"
                  label="Forest Account Name"
                  placeholder="Forest Account Name"
                  value={currentMapping.account_name}
                  type="text"
                  onChange={evt =>
                    updateCurrentMapping('account_name', evt.target.value)
                  }
                  variant="filled"
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <br />
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Typography>Addepar Direct Owner ID:</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="Direct Owner ID"
                label="Direct Owner ID"
                placeholder="Direct Owner ID"
                value={currentMapping.owner_id}
                type="text"
                onChange={evt =>
                  updateCurrentMapping('owner_id', evt.target.value)
                }
                variant="filled"
              />
            </FormControl>
          </Grid>
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
              <Typography>Addepar Entity ID:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id="Entity ID"
                  label="Entity ID"
                  placeholder="Entity ID"
                  value={currentMapping.entity_id}
                  type="text"
                  onChange={evt =>
                    updateCurrentMapping('entity_id', evt.target.value)
                  }
                  variant="filled"
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}>
        <Button
          onClick={() => setIndex(0)}
          style={{
            zIndex: 1,
            backgroundColor: '#c5c7c6',
            height: '30px',
            border: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0px 32px',
            margin: '16px 32px 0px 32px',
            color: 'black',
          }}>
          Back
        </Button>
        <div style={{display: 'flex'}}>
          <Button
            disabled={loading}
            style={{
              zIndex: 1,
              backgroundColor: '#c5c7c6',
              height: '30px',
              border: '0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '16px 0px 0px 32px',
              color: 'black',
            }}
            onClick={addNewMapping}>
            Save and New
          </Button>
          <Button
            disabled={loading}
            style={{
              zIndex: 1,
              backgroundColor: '#c5c7c6',
              height: '30px',
              border: '0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '16px 32px 0px 32px',
              color: 'black',
            }}
            onClick={handleDone}>
            Done
          </Button>
        </div>
      </div>
    </div>
  );
};
